import React from "react";
import { Link, useNavigate, Outlet, useParams, useLoaderData, useOutlet } from "react-router-dom";

import * as APIMEJORATE from "../services/mejorate";

import { ReactComponent as StarSpark } from "../img/icon-start-sparks.svg";

// Función loader
export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }

  const data = await APIMEJORATE.getAllMejorateByTax(params.tratamientoId);
  //const data = await APIMEJORATE.getAllMejorate();

  let firstCannabis = null;
  let firstAlcohol = null;
  let firstCocaina = null;
  let firstBenzo = null;

  for (const item of data) {
    const type = item.meta?.mejorateTipo;
    if (type === "Cannabis" && !firstCannabis) firstCannabis = item;
    if (type === "Alcohol" && !firstAlcohol) firstAlcohol = item;
    if (type === "Cocaína" && !firstCocaina) firstCocaina = item;
    if (type === "Benzodiazepinas" && !firstBenzo) firstBenzo = item;

    // Si ya encontramos los cuatro, podemos romper el bucle
    if (firstCannabis && firstAlcohol && firstCocaina && firstBenzo) break;
  }

  return {
    data,
    firstCannabis,
    firstAlcohol,
    firstCocaina,
    firstBenzo
  };
}

export default function MejorateIntro() {
  const outlet = useOutlet();
  const { data } = useLoaderData(); // Cargar datos del loader
  const { tratamientoId } = useParams(); // Obtener el ID de la URL actual

  return (
    <>
      {outlet ? (
        outlet
      ) : (
        <div id="content" className="full">
          {data?.length > 0 ? (
            <div className="cuestionario-container">
              <div
                className="intro-step"
                style={{ textAlign: "center", padding: "20px" }}
              >
                <StarSpark style={{ width: "80px", height: "80px", marginBottom: "20px" }} />
                <h2 className="is-size-2 has-text-weight-semibold mb-4">
                  ¡Bienvenido/a a Mejórate!
                </h2>
                <p style={{ marginBottom: "10px"}}>Te invitamos a participar en este breve test interactivo diseñado para apoyar tu recuperación. Ponte a prueba y descubre conocimientos y estrategias para tu bienestar.</p>
                <p style={{ marginBottom: "10px"}}>¡Cada respuesta correcta te acercará un paso más hacia tus objetivos! Comienza ahora y disfruta del camino hacia una mejor calidad de vida.</p>
                <p style={{ marginBottom: "10px"}}>¡Ah!, y por cada respuesta correcta añade 0,50€ a tus Ganancias.</p>
                <p>¡Mucha suerte!</p>
                <Link
                  to={`/perfil/${tratamientoId}/mejorate/cuestionarios`}
                  className="button is-link mt-6"
                >
                  Comenzar
                </Link>
              </div>
            </div>
          ) : (
            <div className="no-cuestionario">
              <h2>No existen cuestionarios disponibles para completar</h2>
            </div>
          )}
        </div>
      )}
    </>
  );
}
